/**
 * @description These are base black and white color styles to quickly swap out if you need to.
 */

const base = {
  White: "#FFFFFF",
  Black: "#000000",
};

export default base;
